import Vue from 'vue'
import ElementUI from 'element-ui'
import filters from './utils/filters';
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import store from './store/index'
import { MessageBox } from 'element-ui'
import './service/index'
import appsettings from './utils/appsettings';
import { fetch } from './utils/request';
import "swiper/css/swiper.css";

// import 'swiper/dist/css/swiper.min.css';
// import 'swiper/js/swiper.min';
import Router from 'vue-router'
import asyncExport from "./components/asyncExport";

Vue.prototype.$http = axios
Vue.prototype.$appsettings = appsettings;
Vue.use(ElementUI)
Vue.use(appsettings)
Vue.component("asyncExport", asyncExport)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    let url = document.URL;
    if (to.fullPath === "/" || to.fullPath === "/login") {
        if (url.indexOf("http://www.zhanxiaobang.cn") == 0 || url.indexOf("https://www.zhanxiaobang.cn") == 0 || url.indexOf("http://www.gyh1.com:703") == 0 || url.indexOf("http://localhost:8083") == 0) {
            next();
        } else {
            store.commit('setifUserPortal', true);
            if (url.indexOf("http://lanbo.zhanxiaobang.cn/#/") >= 0) {
                document.title = "青岛蓝博国际会展有限公司";
                let link_icon = document.getElementById("link_icon");
                link_icon.href = "http://" + window.location.host + "/static/lanbo_logo.png"
                next('exiLogin');
            } else {
                next("exhIndex");
            }
        }
    } else {
        if (from.name != 'editExi') {
            store.commit('editExi', { number: 0 })
        }

        if (to.meta.needSelect) {
            store.commit('setNavSelect', true)
        } else {
            store.commit('setNavSelect', false)
        }

        if (to.meta.needBanner) {
            store.commit('setShowBanner', true)
        } else {
            store.commit('setShowBanner', false)
        }

        if (to.meta.title) {
            document.title = to.meta.title;
        }
        next()
    }

})

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js